import { Component } from '@angular/core';

/**
 * Kept for backward compatibility. Re-login after session expiry is now
 * handled by AuthService.registerSessionExpiryHandler() which calls
 * OidcSecurityService.authorize() directly.
 */
@Component({
    selector: 'auth-relogin',
    template: '',
    standalone: false
})
export class AuthReloginComponent { }

